<template>
	<div class="white-box-wrapper" :class="{ 'mobile': getMobileAppState }">
		<div class="contacts-wrapper" :class="{ 'mobile': getMobileAppState }">
			<!-- Contact Block -->
			<divider-generic dividerSize="medium" icon="phone" :title="t('contacts.callCenter.emis')" :applyBorder="false"/>
			<div class="sub-title">{{ t('contacts.callCenter.clientService') }}</div>
			<div class="phones" :class="{ 'mobile': getMobileAppState }">
				<text-block-phone :params="paramsPhoneOne"/>
				<text-block-phone :params="paramsPhoneTwo"/>
				<text-block-phone :params="paramsPhoneThree"/>
			</div>
		</div>
	</div>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockPhone from '@/components/generic/textBlocks/Phone'

/* Assets & Helpers */
import { ref } from 'vue'
import { PHONE_NUMBER_WITH_3_INDICATIVE } from '@/assets/constants/masks'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapGetters */
const { getMobileAppState } = mapGetters()

/* Params */
const paramsPhoneOne = ref({
	phoneNumber: '+244222641840',
	mask: PHONE_NUMBER_WITH_3_INDICATIVE
})

const paramsPhoneTwo = ref({
	phoneNumber: '+244222641849',
	mask: PHONE_NUMBER_WITH_3_INDICATIVE
})

const paramsPhoneThree = ref({
	phoneNumber: '+244923168840',
	mask: PHONE_NUMBER_WITH_3_INDICATIVE
})
</script>

<style lang="scss" scoped>
.white-box-wrapper {
	width: 100%;
	margin: 16px 0 16px;
}
.contacts-wrapper {
	display: flex;
	width: 508px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	margin: 0 auto 0;

	&.mobile {
		width: 100%;
		justify-content: space-between;
	}
}
.phones {
	display: flex;
	flex-direction: column;
	gap: 24px;

	&.mobile {
		width: 100%;
	}
}
.sub-title {
	@include H6-Regular;
	line-height: 18px;
	color: var(--secondary-dark-2);
	overflow: hidden;
}
</style>
